module.exports = __webpack_public_path__ + "static/icons/icon-close-circle-15998a4bcde57f4e649be963874777a9.svg";